<template>
  <modal v-if="showErrorModal" :title="title" @close="showErrorModal = false">
    <div v-html="errors"></div>
  </modal>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
export default {
  components: {
    Modal,
  },
  props: {
    errors: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      showErrorModal: false,
    }
  },
  watch: {
    errors() {
      this.showErrorModal = !!this.errors
    },
  },
}
</script>
<style scoped></style>
